/**
 *Created by jmmartinez on 3/8/18
 **/

//Pasamos cadena con comas y devolvemos flotante sin redondear
export const stringComasToFloat = (valor) => {
    if (valor) {
        //1. pasamos las comas a puntos
        // /,/g  --> g: búsqueda global de comas, para que sustituya todas
        let valorPuntos= valor.replace(/,/g , ".");
        return parseFloat(valorPuntos);
    }
    return valor;
}

//Pasamos cadena con puntos y redondeamos y devolvemos flotante
export const stringTo2FloatDecimales = (valor) => {
    return parseFloat(parseFloat(valor).toFixed(2));
}

//Pasamos cadena con comas y redondeamos y devolvemos flotante
export const stringComasToFloat2Decimales = (valor) => {
    if (valor) {
        //1. pasamos las comas a puntos
        // /,/g  --> g: búsqueda global de comas, para que sustituya todas
        let valorPuntos= valor.replace(/,/g , ".");
        return parseFloat(parseFloat(valorPuntos).toFixed(2));
    }
    return valor;
}

//Pasamos flotante y devolvemos flotante redondeado
export const floatToFloat2Decimales = (valor) => {
    if (valor) {
        return parseFloat(parseFloat(valor).toFixed(2));
    }
    return valor;
}

export const floatToMoneda = (valor) => {
    if (valor){
        return valor.toFixed(2) // Limitamos a dos decimales
            .replace(/\d(?=(\d{3})+\.)/g, '$&.') // Añadimos puntos a los miles
            .replace('.', ',') + ' €'; // Cambiamos el punto decimal por una coma y añadimos el símbolo €

    }
}